import React, { useEffect } from "react"
// eslint-disable-next-line no-restricted-imports
import { Container } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { CenteredLoadingIndicator } from "../../../views/molecules/Molecules"
import { useRoutingFlow } from "../../shared/RoutingFlowContainer"
import { waitForMinimumDelay } from "#/utils/WaitForMinimumDelay"
import { useRequestNewCaseRateRenewalCarrotPlan } from "../../case-rate-renewals/useQueryCaseRateRenewals"
import {
  useRequestJourneyChangeCarrotPlan,
  useRequestCheckInCarrotPlan,
  useRequestInitialCarrotPlan
} from "../../shared/useQueryRoutingInfo"
import {
  CarrotPlanRequestType,
  useGetInProgressCarrotPlanRequestTypeWithMessage
} from "#/components/carrot-plans/hooks/useGetInProgressCarrotPlanRequestType"

export default function ProcessInitialCarrotPlanChatRequestedStep(): JSX.Element {
  const { send } = useStateMachine(null)
  const { setShowProgressTracker } = useRoutingFlow()
  const requestNewCaseRateRenewalCarrotPlan = useRequestNewCaseRateRenewalCarrotPlan()
  const requestJourneyChangeCarrotPlan = useRequestJourneyChangeCarrotPlan()
  const requestCheckInCarrotPlan = useRequestCheckInCarrotPlan()
  const requestInitialCarrotPlan = useRequestInitialCarrotPlan()
  const inProgressRequestTypeQuery = useGetInProgressCarrotPlanRequestTypeWithMessage()

  useEffect(() => {
    setShowProgressTracker(false)
    if (!inProgressRequestTypeQuery.isLoading && inProgressRequestTypeQuery.data) {
      switch (inProgressRequestTypeQuery.data.toString()) {
        case CarrotPlanRequestType.RENEWAL_INTAKE:
          requestNewCaseRateRenewalCarrotPlan.mutate(null, {
            onSuccess: () => {
              send("")
            }
          })
          break
        case CarrotPlanRequestType.JOURNEY_CHANGE_INTAKE:
          requestJourneyChangeCarrotPlan.mutate(null, {
            onSuccess: () => {
              send("")
            }
          })
          break
        case CarrotPlanRequestType.CHECK_IN_INTAKE:
          requestCheckInCarrotPlan.mutate(null, {
            onSuccess: () => {
              send("")
            }
          })
          break
        case CarrotPlanRequestType.INITIAL_INTAKE:
        case "NO_CPES":
          waitForMinimumDelay(requestInitialCarrotPlan.mutateAsync(null), 1000).then(() => {
            send("")
          })
          break
        case "NO_IN_PROGRESS_CPES":
          send("")
          break
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See https://carrotfertility.atlassian.net/wiki/spaces/PE/pages/2050295461/Remove+Build+Warnings#react-hooks%2Fexhaustive-deps
  }, [inProgressRequestTypeQuery.data])

  return (
    <>
      <Container padding="large" stack="giant">
        <CenteredLoadingIndicator data-testid="carrot-plan-loader" />
      </Container>
    </>
  )
}
